module.exports = __webpack_public_path__ + "assets/img/star_sentence_select8.5765821b.png";